<ftr-icon [icon]="icon()" size="Regular"></ftr-icon>
<span class="label">{{ label() }}</span>
<span class="result-count">{{ getResultCountText() }}</span>
